
declare global {
    interface Window {
        __tcfapiprivate?: any;
        __tcfapi?: any;
    }
}

export class MeteoredCMPAdapter {

    public static initCMPListener(callback: () => void): void {
        if (!window.__tcfapiprivate) {
            callback();
            return;
        }

        window.__tcfapiprivate('addEventListener', 'isConfigured', (tcData: any, success: any) => {
            if (!window.__tcfapi) {
                callback();
                return;
            }
            window.__tcfapi('addEventListener', 2, (tcData: any, success: boolean) => {
                if (tcData.eventStatus === 'useractioncomplete' || tcData.eventStatus === 'tcloaded') {

                    callback();

                    window.__tcfapi('removeEventListener', 2, (success: boolean) => {
                    }, tcData.listenerId);
                }
            });
        });
    }
}
